import { Component, OnInit } from '@angular/core';
import { DateTime } from "luxon";
import { SettlementItem, SettlementResponse } from "src/app/services/utility.service";
import { DashboardDataService } from 'src/app/services/dashboard-data.service';
import { finalize } from 'rxjs/operators';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-settlement',
  templateUrl: './settlement.component.html',
  styleUrls: ['./settlement.component.scss'],
})
export class SettlementComponent implements OnInit {

  public masterSettlements: SettlementItem[] = []; 
  filteredSettlements: SettlementItem[] = [];   
  maxDate: string = "";
  selectedDate: string = "";
  isLoading = false;
  errorMessage: string | null = null;
  searchTerm: string = '';
  selectedBidType: string = 'All';

  constructor(
    private dashboardData: DashboardDataService,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit() {
    const todayISO = DateTime.local().toISODate(); 
    this.selectedDate = todayISO ?? "";
    this.maxDate = todayISO ?? ""; 
    this.fetchSettlements();
  }

  fetchSettlements(): void {
    this.isLoading = true;
    this.errorMessage = null;
    
    const utilityId = this.localStorageService.getUserId();


    if (!utilityId && !this.dashboardData.isPartnerSession()) {
      this.isLoading = false;
      this.errorMessage = 'Utility ID not found. Cannot load settlement details.';
      this.masterSettlements = [];
      this.applyFilters();
      return;
    }

    this.dashboardData.getSettlementHistory(
      this.selectedDate,
      this.selectedDate
    ).pipe(
      finalize(() => this.isLoading = false)
    ).subscribe({
      next: (response: SettlementResponse) => {
        this.masterSettlements = response.items;
        this.applyFilters(); 
      },
      error: (err) => {
        console.error('Failed to fetch settlement history:', err);
        this.errorMessage = 'Could not load settlement details. Please try again later.';
        this.masterSettlements = [];
        this.applyFilters(); 
      }
    });
  }


  applyFilters(): void {
    let settlements = [...this.masterSettlements];

    const term = this.searchTerm.toLowerCase();
    if (term) {
      settlements = settlements.filter(s => 
        s.customer_name.toLowerCase().includes(term)
      );
    }

    if (this.selectedBidType !== 'All') {
      settlements = settlements.filter(s => s.bid_type === this.selectedBidType);
    }

    this.filteredSettlements = settlements;
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchTerm = input.value;
    this.applyFilters();
  }

  onFilterChange(event: Event): void {
    const select = event.target as HTMLSelectElement;
    this.selectedBidType = select.value;
    this.applyFilters();
  }

  onDateChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.selectedDate = input.value;
    this.fetchSettlements();
  }

  onMatDateChange(event: any): void {
    if (event.value) {
      const dt = DateTime.fromJSDate(event.value);
      this.selectedDate = dt.toISODate() ?? this.selectedDate;
      this.fetchSettlements();
    }
  }

  changeDay(amount: number): void {
    this.selectedDate = DateTime.fromISO(this.selectedDate).plus({ days: amount }).toISODate() ?? "";
    this.fetchSettlements();
  }
}